import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Col } from 'react-bootstrap';
import styles from './style';
import StepperIcon from './StepperIcon';

const StepProgress = (props) => {
  const { typeTrans, date, status, length, index, isDetailLoad, cancellationStatus } = props;
  return (
    <Col lg={12} md={12} className="p-0">
      {index === 0 ? (
        <StepperIcon
          typeTrans={typeTrans}
          type={status}
          title={Moment(date).format('DD MMM YYYY HH:mm')}
          isDetailLoad={isDetailLoad}
          cancellationStatus={cancellationStatus}
        />
      ) : (
        <Col lg={12} md={12} className="p-0">
          {typeTrans === 'deposit' ? (
            <Col lg={12} md={12} className="p-0" style={styles.lineConnectorDeposit} />
          ) : (
            <Col lg={12} md={12} className="p-0" style={styles.lineConnectorWithdraw} />
          )}
          <StepperIcon
            index={index}
            length={length}
            typeTrans={typeTrans}
            type={status}
            title={Moment(date).format('DD MMM YYYY HH:mm')}
            isDetailLoad={isDetailLoad}
            cancellationStatus={cancellationStatus}
          />
        </Col>
      )}
    </Col>
  );
};

StepProgress.propTypes = {
  transactionDetailData: PropTypes.shape({
    type: PropTypes.string,
    ref_code: PropTypes.string,
    amount: PropTypes.number,
    created_at: PropTypes.string,
    status_changes: PropTypes.arrayOf({}),
  }),
  cancellationStatus: PropTypes.shape({
    reason: PropTypes.string,
    source: PropTypes.string,
  }),
};

StepProgress.defaultProps = {
  transactionDetailData: null,
  cancellationStatus: null,
};

export default StepProgress;
